import { useQuery } from '@tanstack/react-query';
import { searchService } from '../services/search.service';

export function useGlobalSearch(query: string) {
  return useQuery({
    queryKey: ['search', query],
    queryFn: () => searchService.global(query),
    enabled: query.trim().length >= 2,
    staleTime: 5000,
  });
}
